"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _rebrand = require("@lt/components/icons-react/rebrand");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.DropdownIndicator, props, /*#__PURE__*/_react["default"].createElement(StyledSelectArrow, null));
};

exports.DropdownIndicator = DropdownIndicator;
var StyledSelectArrow = (0, _styledComponents["default"])(_rebrand.ChevronDown).withConfig({
  displayName: "DropdownIndicator__StyledSelectArrow",
  componentId: "sc-10jl5p4-0"
})(["height:13px;& > path{fill:var(--grey2);}"]);